import { styled, Box } from '@mui/material';
import { WsTypoColors, WsTypography } from 'wisestep-base';

import NoEmailCampaignResponseImage from '../../../../images/NoResponseEmailCampaign.svg';

const StyledNoResponseBox = styled(Box)(({ theme }) => ({
  minHeight: 500,
  width: '100%',
  display: 'flex',
  rowGap: theme.spacing(1.5),
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const NoEmailCampaignResponse = ({
  text = 'Email with responses not available',
  subText = 'Please check back later',
}: {
  text?: string;
  subText?: string;
}) => {
  return (
    <StyledNoResponseBox>
      <img src={NoEmailCampaignResponseImage} alt="No Email Campaign Response" />
      <WsTypography bold>{text}</WsTypography>
      <WsTypography color={WsTypoColors.SECONDARY}>{subText}</WsTypography>
    </StyledNoResponseBox>
  );
};
